import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["read-only"]
const _hoisted_2 = {
  key: 0,
  class: "cuscd-form-field-label"
}
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = {
  key: 0,
  class: "help"
}
const _hoisted_5 = {
  key: 1,
  class: "hint"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["value", "placeholder"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value", "selected"]
const _hoisted_10 = ["checked"]
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "help"
}
const _hoisted_14 = {
  key: 1,
  class: "hint"
}
const _hoisted_15 = { class: "label" }
const _hoisted_16 = ["checked", "value", "name", "onChange"]
const _hoisted_17 = {
  key: 6,
  class: "autocomplete-container"
}
const _hoisted_18 = ["type", "name", "value", "placeholder"]
const _hoisted_19 = { class: "results-wrapper" }
const _hoisted_20 = {
  class: "autocomplete-results",
  ref: "autocompleteResults"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["name", "value", "allowDecimals", "allowZero"]
const _hoisted_23 = ["name", "value", "placeholder", "maxlength"]
const _hoisted_24 = ["name", "value"]
const _hoisted_25 = ["type", "name", "value", "placeholder", "autocomplete"]
const _hoisted_26 = {
  key: 11,
  class: "hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-field", { checkbox: _ctx.schema.type === 'checkbox' }]),
    "read-only": _ctx.readOnly
  }, [
    (_ctx.field.type !== 'checkbox' && _ctx.field.type !== 'radio' && !_ctx.field.hideLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _renderSlot(_ctx.$slots, "label", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.field.label ? _ctx.field.label : " "), 1),
            (_ctx.field.label && _ctx.field.required && _ctx.field.showRequiredIndicator)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
              : _createCommentVNode("", true)
          ], true),
          (_ctx.hasHelpSlot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_icon, { icon: "info" }),
                _createElementVNode("div", {
                  class: _normalizeClass(["tooltip", _ctx.field.tooltipLocation])
                }, [
                  _renderSlot(_ctx.$slots, "help", {}, () => [
                    _cache[27] || (_cache[27] = _createTextVNode(" Shalom from the tooltip! ", -1))
                  ], true)
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.$slots.hint &&
        _ctx.schema.hintPosition === 'top' &&
        _ctx.field.type !== 'checkbox' &&
        _ctx.field.type !== 'radio'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.field.type === 'readonly')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.modelValue), 1))
      : (_ctx.field.type === 'select')
        ? (_openBlock(), _createElementBlock("select", _mergeProps({
            key: 3,
            value: _ctx.modelValue,
            placeholder: _ctx.field.placeholder ? _ctx.field.placeholder : undefined,
            class: ["form-control", {
        'is-invalid': _ctx.schema.touched && !_ctx.schema.valid,
      }]
          }, _ctx.$attrs, {
            onChange: _cache[0] || (_cache[0] = ($event: any) => {
        _ctx.$emit('update:modelValue', ($event.target as any).value);
        _ctx.validate(_ctx.schema, ($event.target as any).value, _ctx.compare);
      }),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validate(_ctx.schema, ($event.target as any).value, _ctx.compare)))
          }), [
            _createElementVNode("option", {
              value: "",
              class: "default",
              disabled: _ctx.isDefaultDropdownOptionDisabled
            }, [
              _renderSlot(_ctx.$slots, "default-option", {}, undefined, true)
            ], 8, _hoisted_8),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: option.value ? option.value : option,
                key: index,
                selected: option === _ctx.modelValue
              }, _toDisplayString(option.label ? option.label : option), 9, _hoisted_9))
            }), 128))
          ], 16, _hoisted_7))
        : (_ctx.field.type === 'checkbox')
          ? (_openBlock(), _createElementBlock("label", _mergeProps({ key: 4 }, _ctx.$attrs, { class: "checkbox-container" }), [
              _renderSlot(_ctx.$slots, "label", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.field.label ? _ctx.field.label : " "), 1)
              ], true),
              _createElementVNode("input", _mergeProps(_ctx.$attrs, {
                class: ["form-check-input", {
          'is-invalid': _ctx.schema.touched && !_ctx.schema.valid,
        }],
                type: "checkbox",
                checked: _ctx.modelValue as any,
                onChange: _cache[2] || (_cache[2] = ($event: any) => {
          _ctx.$emit('update:modelValue', ($event.target as any).checked);
          _ctx.validate(_ctx.schema, ($event.target as any).checked, _ctx.compare);
        })
              }), null, 16, _hoisted_10),
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "checkmark" }, null, -1))
            ], 16))
          : (_ctx.field.type === 'radio' && _ctx.options && _ctx.options.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (!_ctx.field.hideLabel)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
                      _renderSlot(_ctx.$slots, "label", {}, () => [
                        _createTextVNode(_toDisplayString(_ctx.field.label ? _ctx.field.label : " "), 1)
                      ], true),
                      (_ctx.hasHelpSlot)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_icon, { icon: "info" }),
                            _createElementVNode("div", {
                              class: _normalizeClass(["tooltip", _ctx.field.tooltipLocation])
                            }, [
                              _renderSlot(_ctx.$slots, "help", {}, () => [
                                _cache[29] || (_cache[29] = _createTextVNode(" Shalom from the tooltip! ", -1))
                              ], true)
                            ], 2)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$slots.hint && _ctx.schema.hintPosition === 'top')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _mergeProps(_ctx.$attrs, { class: "radio-btns-container" }), [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: option.value,
                      class: "radio-container"
                    }, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(option.label ? option.label : ""), 1),
                      _createElementVNode("input", _mergeProps({
                        ref_for: true,
                        ref: "radioInput",
                        type: "radio",
                        checked: _ctx.modelValue === option.value || _ctx.modelValue === option,
                        value: option.value,
                        name: _ctx.field.label || 'radio-group',
                        onChange: ($event: any) => (_ctx.$emit('update:modelValue', option.value !== undefined ? option.value : option))
                      }, { ref_for: true }, _ctx.$attrs), null, 16, _hoisted_16),
                      _createElementVNode("span", {
                        class: _normalizeClass(["checkmark", { checked: _ctx.checked }])
                      }, null, 2)
                    ]))
                  }), 128))
                ], 16)
              ]))
            : (_ctx.field.type === 'autocomplete')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("input", _mergeProps(_ctx.$attrs, {
                    class: ["form-control", {
          'is-invalid': _ctx.schema.touched && !_ctx.schema.valid,
        }],
                    autocomplete: "off",
                    type: _ctx.schema.type === 'compare' ? _ctx.schema.compareType : _ctx.schema.type,
                    name: _ctx.schema.name ? _ctx.schema.name : undefined,
                    value: _ctx.autocompleteSearch,
                    placeholder: _ctx.field.placeholder ? _ctx.field.placeholder : undefined,
                    onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleAutoCompleteFocus && _ctx.handleAutoCompleteFocus(...args))),
                    onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleAutoCompleteBlur(_ctx.schema, _ctx.modelValue, _ctx.compare))),
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onAutocompleteChange($event))),
                    onKeydown: [
                      _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                      _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                      _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                    ],
                    onKeyup: _cache[9] || (_cache[9] = ($event: any) => (
          _ctx.validateOnKeyUp || _ctx.schema.touched ? _ctx.validate(_ctx.schema, _ctx.modelValue, _ctx.compare) : undefined
        ))
                  }), null, 16, _hoisted_18),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("div", {
                      ref: "autocompleteSearchInputError",
                      class: "results-error"
                    }, _toDisplayString(_ctx.autoCompleteResultsErrorMessage), 513), [
                      [_vShow, _ctx.autoCompleteIsOpen && _ctx.autoCompleteResults.length === 0]
                    ]),
                    _withDirectives(_createElementVNode("ul", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoCompleteResults, (result, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.autoCompleteArrowCounter }]),
                          onClick: ($event: any) => (_ctx.setAutocompleteValue(result, true))
                        }, _toDisplayString(_ctx.schema.autocompleteProperty ? (result as any)[_ctx.schema.autocompleteProperty] : result), 11, _hoisted_21))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.autoCompleteIsOpen && _ctx.autoCompleteResults.length > 0]
                    ])
                  ])
                ]))
              : (_ctx.field.type === 'money')
                ? _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({ key: 7 }, _ctx.$attrs, {
                    type: "text",
                    class: ["form-control money", {
        'is-invalid': _ctx.schema.touched && !_ctx.schema.valid,
      }],
                    name: _ctx.schema.name ? _ctx.schema.name : undefined,
                    value: _ctx.modelValue,
                    allowDecimals: _ctx.schema.allowDecimals ? _ctx.schema.allowDecimals : true,
                    allowZero: _ctx.schema.allowZero ? _ctx.schema.allowZero : undefined,
                    onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as any).value))),
                    onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validate(_ctx.schema, _ctx.modelValue, _ctx.compare))),
                    onKeypress: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validate(_ctx.schema, _ctx.modelValue, _ctx.compare))),
                    onKeyup: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateOnKeyUp || _ctx.schema.touched ? _ctx.validate(_ctx.schema, _ctx.modelValue, _ctx.compare) : undefined))
                  }), null, 16, _hoisted_22)), [
                    [_directive_maska, _ctx.schema.allowDecimals ? '#*.##' : '#*']
                  ])
                : (_ctx.field.type === 'zipcode')
                  ? (_openBlock(), _createElementBlock("input", _mergeProps({ key: 8 }, _ctx.$attrs, {
                      ref: "zipInput",
                      type: "text",
                      class: ["form-control", {
        'is-invalid': _ctx.schema.touched && !_ctx.schema.valid,
      }],
                      name: _ctx.schema.name ? _ctx.schema.name : undefined,
                      value: _ctx.cleanedValue || _ctx.modelValue,
                      placeholder: _ctx.field.placeholder ? _ctx.field.placeholder : undefined,
                      maxlength: _ctx.modelValue ? ((_ctx.modelValue as string).includes('-') ? 10 : 9) : undefined,
                      onPaste: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handlePaste($event))),
                      onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.cleanedValue = undefined)),
                      onKeydown: _cache[16] || (_cache[16] = ($event: any) => (_ctx.validateZipCodeInput($event))),
                      onKeypress: _cache[17] || (_cache[17] = ($event: any) => (_ctx.validateZipCodeInput($event))),
                      onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as any).value))),
                      onBlur: _cache[19] || (_cache[19] = ($event: any) => {
        _ctx.handleOnBlur();
        _ctx.validate(_ctx.schema, _ctx.modelValue, _ctx.compare);
      }),
                      onKeyup: _cache[20] || (_cache[20] = ($event: any) => (_ctx.validateOnKeyUp || _ctx.schema.touched ? _ctx.validate(_ctx.schema, _ctx.modelValue, _ctx.compare) : undefined))
                    }), null, 16, _hoisted_23))
                  : (_ctx.field.type === 'textarea')
                    ? (_openBlock(), _createElementBlock("textarea", _mergeProps({ key: 9 }, _ctx.$attrs, {
                        class: ["form-control", {
        'is-invalid': _ctx.schema.touched && !_ctx.schema.valid,
      }],
                        name: _ctx.schema.name ? _ctx.schema.name : undefined,
                        value: (_ctx.modelValue as string | undefined | null),
                        onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as any).value)))
                      }), null, 16, _hoisted_24))
                    : _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({ key: 10 }, _ctx.$attrs, {
                        class: ["form-control", {
        'is-invalid': _ctx.schema.touched && !_ctx.schema.valid,
        valid:
          _ctx.schema.touched &&
          _ctx.schema.valid &&
          (_ctx.schema.type === 'email' ||
            _ctx.schema.type === 'phone' ||
            _ctx.schema.type === 'password' ||
            _ctx.schema.type === 'compare'),
      }],
                        type: _ctx.schema.type === 'compare' ? _ctx.schema.compareType : _ctx.schema.type,
                        name: _ctx.schema.name ? _ctx.schema.name : undefined,
                        value: _ctx.modelValue,
                        placeholder: _ctx.field.placeholder ? _ctx.field.placeholder : undefined,
                        autocomplete: _ctx.field.autocomplete ? _ctx.field.autocomplete : undefined,
                        onKeydown: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validateInput($event))),
                        onKeypress: _cache[23] || (_cache[23] = ($event: any) => (_ctx.validateInput($event))),
                        onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as any).value))),
                        onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleBlur(_ctx.schema, _ctx.modelValue, _ctx.compare))),
                        onKeyup: _cache[26] || (_cache[26] = ($event: any) => (_ctx.validateOnKeyUp || _ctx.schema.touched ? _ctx.validate(_ctx.schema, _ctx.modelValue, _ctx.compare) : undefined))
                      }), null, 16, _hoisted_25)), [
                        [_directive_maska, _ctx.schema.type === 'phone' ? '(###) ###-####' : undefined]
                      ]),
    (_ctx.$slots.hint && _ctx.schema.hintPosition === 'bottom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.errors)
      ? _renderSlot(_ctx.$slots, "errors", { key: 12 }, undefined, true)
      : (_openBlock(), _createElementBlock("ul", {
          key: 13,
          class: _normalizeClass(["invalid-feedback", {
        multiple: _ctx.schema.errors && _ctx.schema.errors.length > 1,
      }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema.errors, (error, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
          }), 128))
        ], 2))
  ], 10, _hoisted_1))
}